import {EOperationType} from "../models/utils/EOperationType";
import {AOperation} from "../models/operations/AOperation";
import {InstallationElement} from "../models/operations/InstallationElement";
import {Geolocate} from "../models/operations/Geolocate";
import {InstallationEquipment} from "../models/operations/InstallationEquipment";
import {UninstallElement} from "../models/operations/UninstallElement";
import {ReplaceElement} from "../models/operations/ReplaceElement";
import UninstallEquipment from "../models/operations/UninstallEquipment";
import AuthenticationLocalService from "./storage/localStorage/AuthenticationLocalService";

class OperationService {

    public convertOperationTypeToOperation(operationData: AOperation | EOperationType): AOperation {
        const isType = typeof operationData === "number";
        let operation: AOperation;
        if(isType) {
            operation = this.createsOperationAccordingToType(operationData as number);
        } else {
            operation = operationData as AOperation;
        }
        return operation;
    }

    createsOperationAccordingToType(operationType: EOperationType): AOperation {
        let operation: AOperation;
        const date = new Date();
        const id = date.getTime().toString();
        const idUser = AuthenticationLocalService.getCurrentUser()!.id;
        switch (operationType) {
            case EOperationType.InstallationElement:
                operation = new InstallationElement(id, idUser, date);
                break;
            case EOperationType.Geolocate:
                operation = new Geolocate(id, idUser, date);
                break;
            case EOperationType.InstallationEquipment:
                operation = new InstallationEquipment(id, idUser, date)
                break;
            case EOperationType.UninstallationElement:
                operation = new UninstallElement(id, idUser, date);
                break;
            case EOperationType.ReplacementElement:
                operation = new ReplaceElement(id, idUser, date);
                break;
            case EOperationType.UninstallationEquipment:
                operation = new UninstallEquipment(id, idUser, date);
                break;
            default:
                operation = new InstallationEquipment(id, idUser, date)
                break;
        }
        return operation;
    }

}

export default new OperationService();
